<template>
  <div class="items__list">
    <vs-table
      stripe
      v-model="selected"
      search
      @dblSelection="doubleSelection"
      :data="items"
    >
      <template slot="header">
        <h3>Supplies ({{ items.length }})</h3>
        <!-- <div class="items__filter">
          <div class="label">Status</div>
          <vs-select v-model="selfStatus" @change="updateStatusHandler">
            <vs-select-item value="0" text="Deactivated" />
            <vs-select-item value="1" text="Active" />
          </vs-select>
        </div> -->
      </template>
      <template slot="thead">
        <vs-th sort-key="img"></vs-th>
        <vs-th sort-key="name">Name</vs-th>
        <vs-th sort-key="total_count">Count</vs-th>
        <vs-th></vs-th>
      </template>
      <template slot-scope="{ data }">
        <vs-tr :data="tr" :key="tr.id" v-for="(tr, indextr) in data">
          <vs-td :data="data[indextr].files[0]">
            <img class="item-thumb"
            :src="proxy + data[indextr].files[0].thumb_path"
            v-if="data[indextr].files.length && imgExtensionsList.indexOf(getThumbExt(data[indextr].files[0].name)) != -1"
          />
          </vs-td>
          <vs-td :data="data[indextr].name">
            {{ tr.name }}
          </vs-td>

          <vs-td
            :data="data[indextr].total_count"
            :class="{
              danger: data[indextr].total_count < data[indextr].min_count,
            }"
            ><span :title="`Min count: ${data[indextr].min_count}`">{{ data[indextr].total_count }}</span></vs-td>
          <vs-td :data="data[indextr].id">
            <vs-button
              :data-id="data[indextr].id"
              radius
              color="dark"
              icon="visibility"
              type="flat"
              @click="
                $router.push({
                  name: 'Item',
                  params: { item_id: data[indextr].id },
                })
              "
            ></vs-button>
            <vs-button
              :data-id="data[indextr].id"
              radius
              color="dark"
              icon="edit"
              type="flat"
              @click="editItemHandler(data[indextr].id)"
            ></vs-button>
            <vs-button
              :data-id="data[indextr].id"
              radius
              color="dark"
              icon="delete"
              type="flat"
              @click="deleteItemHandler(data[indextr].id)"
            ></vs-button>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import imgExtensionsList from '@/components/common/dicts/imageExtensions.js'

export default {
  props: ['status'],
  data() {
    return {
      selfStatus: this.status,
      selected: [],
      selectedId: null,
      proxy: process.env.VUE_APP_PROXY,
      api_url: process.env.VUE_APP_API_URI,
      imgExtensionsList
    }
  },
  computed: {
    ...mapState({
      items: (state) => state.items.items,
    }),
  },
  methods: {
    deleteItemHandler: function (id) {
      this.selectedId = id
      this.openAlert()
    },
    editItemHandler: function (id) {
      this.$emit('editItem', id)
    },
    doubleSelection: function (tr) {
      this.$router.push({ name: 'Item', params: { item_id: tr.id } })
    },
    openAlert: function () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Delete teacher',
        text: 'Are you sure you want to delete the teacher?',
        accept: this.acceptAlert,
      })
    },
    acceptAlert: function () {
      this.$emit('deleteItem', this.selectedId)
      this.selectedId = null
    },
    updateStatusHandler: function (status) {
      this.$emit('updateStatus', status)
    },
    getThumbExt: function(filename){
      return filename.split('.').pop()
    }
  },
}
</script>

<style lang="scss">
.items__list {
  .td {
    &.danger {
      color: red;
    }
    .item-thumb{
      width: 2rem;
      height: 2rem;
    }
  }
}
</style>